const countryEuropeOptions: { [key: string]: string } = {
  AT: 'Austria',
  BE: 'Belgium',
  CY: 'Cyprus',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'France',
  DE: 'Germany',
  GR: 'Greece',
  IR: 'Ireland',
  IT: 'Italy',
  LV: 'Latvia',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MT: 'Malta',
  NL: 'Netherlands',
  PT: 'Portugal',
  SK: 'Slovakia',
  SI: 'Slovenia',
  ES: 'Spain',
};

export default countryEuropeOptions;
